import { Component, Input } from '@angular/core';
import { PolicyValidityStatusCodeEnum, PurchasedProductInterface } from 'outshared-lib';

@Component({
    selector: 'ins-insurance-list-changes',
    templateUrl: 'insurance-list-changes.component.html',
})
export class InsuranceListChangesComponent {
    @Input() public purchasedProduct!: PurchasedProductInterface;
    public validityStatusCodeEnum = PolicyValidityStatusCodeEnum;

    public get hasCoveragesAdjustmentStartDate(): boolean {
        return Boolean(this.purchasedProduct?.coverage?.coveragesAdjustmentStartDate);
    }

    public get hasRegularDriverFuture(): boolean {
        return Boolean(this.purchasedProduct?.productDetails?.regularDriverFuture);
    }

    public get hasRegularDriverEndDate(): boolean {
        return Boolean(
            this.purchasedProduct?.productDetails?.regularDriver?.endDate &&
                !this.purchasedProduct?.productDetails?.regularDriverFuture
        );
    }

    public get hasActivePurchasedProduct(): boolean {
        return ![
            PolicyValidityStatusCodeEnum.Future,
            PolicyValidityStatusCodeEnum.Transfer,
            PolicyValidityStatusCodeEnum.Ended,
        ].includes(this.purchasedProduct?.product?.validityStatusCode);
    }
}
